'use client'
import ChevronIcon from '@/icons/ChevronIcon'
import {useState} from 'react'

type Props = {
  label?: string
  name: string
  options?: string[]
  error?: boolean
}

const Dropdown = ({label, name, options, error}: Props) => {
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState('')

  return (
    <div
      onClick={() => setOpen(prev => !prev)}
      className={`w-full border-b-[0.5px] ${error ? 'border-red' : !value ? 'border-black-low' : 'border-black'} cursor-pointer py-3 text-headline-sm`}
    >
      <div className="flex items-center justify-between">
        <input name={name} defaultValue={value} hidden />
        <span>{!!value ? value : label}</span>
        <ChevronIcon className={open ? 'rotate-180' : ''} />
      </div>
      <ul
        className={`overflow-hidden pt-1 text-black-md transition-[max-height,opacity] duration-200 ease-in-out text-body-lg ${open ? 'max-h-36 opacity-100' : 'max-h-0 opacity-0'}`}
      >
        {options?.map(option => (
          <li
            key={option}
            className={`cursor-pointer hover:text-black ${value === option ? 'text-black' : ''}`}
            onClick={() => setValue(option)}
          >
            {option}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Dropdown
